import Constant from '@/const';
import axios from 'axios';

const getDrugSalesRegistrationCode = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/drugssales/transactioncode'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDrugSalesRegistrationCode;
